import React from 'react';
import classNames from 'classnames';
import Image from '../../elements/Image';

const Logo = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'brand',
    className
  );

  return (
    <div
      {...props}
      className={classes}
    >
      <h1 className="m-0">
          <Image
            src={require('./../../../assets/images/signal-2024-01-23-025520.png')}
            alt="Tidy"
            width={64}
            height={64} />
      </h1>
    </div>
  );
}

export default Logo;